import React from "react";
import values from "../../../../values";
import Context from "../../../../context";
import Components from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../../../components";

import "./index.scss";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";

type Props = {
  rqSuperAgent: any;
};

const SuperAgentScreen = (props: Props) => {
  const { data, status } = props.rqSuperAgent;

  const { requestSuperAgent, setRequestSuperAgent } = React.useContext(
    Context.SuperAgentCityScreen
  );

  const { t } = useTranslation();

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  return (
    <CustomView.Container id="super-agent-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {writePermission === "true" && <Components.Create />}
          <Components.Filter />
          <Components.Search />
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader
            headers={values.tableHeaders.SUPER_AGENT_HEADERS.map((item) =>
              t(item)
            )}
          />
          {status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={data?.result?.docs} />
          )}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestSuperAgent?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestSuperAgent!({ ...requestSuperAgent, page })
              }
            />
          </div>
        )}
      {writePermission === "true" && <Components.Update />}
      <Components.ShowInformation />
    </CustomView.Container>
  );
};

export default SuperAgentScreen;
